import styled from "styled-components";

const NewsItems = styled.div`
  display: flex;
  flex-direction: column;
  padding: 28px 16px;
  gap: 16px;
  overflow-x: hidden;
  overflow-y: auto;
  flex: 1;
`

export default NewsItems